import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { GoogleSignInButton } from "./auth/GoogleSignInButton";
import { DevelopmentSignIn } from "./auth/DevelopmentSignIn";
import { useAuth, useSignIn } from "../auth/auth";
import { AuthScreen } from "./auth/AuthScreen";
import { AuthRejection } from "./auth/AuthRejection";

export function JoinGate() {
  const { t } = useTranslation();
  const auth = useAuth();
  const { signIn, signInDevelopment, signingIn, error, setGoogleError, resetError } = useSignIn();
  const handleGoogleError = useCallback(() => {
    setGoogleError("google-script-unavailable");
  }, [setGoogleError]);
  const authenticated = Boolean(auth.user);
  const waiting = signingIn;
  const shownError = error || auth.error;

  if (!authenticated && (shownError === "account-suspended" || shownError === "signups-closed")) {
    return <AuthRejection reason={shownError} onBack={resetError} />;
  }

  return (
    <AuthScreen id="joinGate" hidden={authenticated} busy={waiting}>
      <h1 className="font-heading text-2xl font-bold">{t("join.title")}</h1>
      <p className="mt-2 mb-5.5 leading-normal text-muted-foreground">{t("join.description")}</p>
      {waiting ? (
        <div className="flex min-h-11 items-center justify-center gap-2.5 text-xs text-muted-foreground">
          <span className="size-4 animate-spin rounded-full border-2 border-white/20 border-t-white [animation-duration:.8s]" />
          {t("auth.signingIn")}
        </div>
      ) : auth.authMode === "mock" ? (
        <DevelopmentSignIn
          onSubmit={(profile: { name: string; email: string }) => signInDevelopment(profile)}
        />
      ) : (
        <GoogleSignInButton
          clientId={auth.clientId}
          disabled={waiting}
          onCredential={signIn}
          onError={handleGoogleError}
        />
      )}
      {shownError ? (
        <p className="mt-3 text-center text-xs text-destructive" role="alert">
          {t(`auth.errors.${shownError}`, {
            defaultValue: t("auth.errors.default"),
          })}
        </p>
      ) : null}
      <small className="mt-4 block text-center text-xs leading-normal text-muted-foreground">
        {t(auth.authMode === "mock" ? "auth.developmentPrivacy" : "auth.privacy")}
      </small>
    </AuthScreen>
  );
}
